export default __webpack_public_path__ + "static/media/divide_white.bc2b7ced.svg";